
import i18n from "i18next";

/**
 * Creates a DOM element, applies CSS classes, and appends it to a parent in one call. Derives the owning
 * document from the parent element, so no separate document reference is needed.
 *
 * @param {HTMLElement} parent - The element to append the new child to.
 * @param {string} tag - The tag name for the new element (e.g. "div", "span", "button").
 * @param {...string} classes - Optional CSS class names to add.
 * @returns {HTMLElement} The newly created element.
 * @private
 */
export function createElement(parent, tag, ...classes) {
  const element = parent.ownerDocument.createElement(tag);
  classes.length && element.classList.add(...classes);
  parent.appendChild(element);
  return element;
}

/**
 * Sets both the data-i18n attribute (for runtime locale switching) and the visible textContent on an element.
 *
 * @param {HTMLElement} element - The element to update.
 * @param {string} key - The i18n key (also used as the data-i18n attribute value).
 * @param {Object} [options] - Optional i18next interpolation options forwarded to i18n.t().
 */
export function setLocalizedText(element, key, options) {
  element.setAttribute("data-i18n", key);
  element.textContent = i18n.t(key, options);
}